<table class="table table-bordered table-hover">
  <thead class="table-dark">
    <tr>
      @if (includeClientColumn) {
        <th>Client</th>
      }
      <th>Location</th>
      <th>Earliest<br /> Record</th>
      <th>Last<br/> Received</th>
      <th>Encounters</th>
      <th>Referrals</th>
      <th>Client<br /> Prescriptions</th>
      <th>Current<br /> Eligibility Status</th>
      <th class="text-center">Eligibility Period</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    @for (patientInteractionLocation of patientInteractionLocations; track patientInteractionLocation) {
      <tr>
        @if (includeClientColumn) {
          <td>
            {{ patientInteractionLocation.client.name }}
          </td>
        }
        <td>
          @if (patientInteractionLocation.blankLocation) {
            <i>(No location name)</i>
          } @else {
            {{ patientInteractionLocation.name }}
          }
        </td>
        <td>{{ patientInteractionLocation.firstServiceDate | date: 'MM/dd/yyyy' | blankValueDash }}</td>
        <td>{{ patientInteractionLocation.lastReceivedAt | date: 'MM/dd/yyyy' | blankValueDash }}</td>
        <td>{{ patientInteractionLocation.encounterCount | number }}</td>
        <td>{{ patientInteractionLocation.referralCount | number }}</td>
        <td>{{ patientInteractionLocation.clientPrescriptionCount | number }}</td>
        <td class="eligibility-status" [ngClass]="patientInteractionLocation.eligibilityStatus">
          {{ keyedEligibilityStatusOptions[patientInteractionLocation.eligibilityStatus].display }}
        </td>
        @if (!patientInteractionLocation.eligibilityPeriodsEnabled) {
          <td
            class="eligibility-periods-disabled"
            colspan="2">
            This client does not manage 340B locations data in the app
          </td>
        } @else if (patientInteractionLocation.blankLocation) {
          <td
            class="eligibility-periods-disabled"
            colspan="2">
            Eligibility update not available
          </td>
        } @else {
          <td class="eligibility-periods">
            <ng-container
              [ngTemplateOutlet]="eligibilityPeriods"
              [ngTemplateOutletContext]="{ patientInteractionLocation: patientInteractionLocation }" />
          </td>
          <td class="location-actions"
            [ngClass]="patientInteractionLocation.eligibilityStatus"
            >
            <ng-container
              [ngTemplateOutlet]="eligibilityActions"
              [ngTemplateOutletContext]="{ patientInteractionLocation: patientInteractionLocation }" />
          </td>
        }
      </tr>
    }
  </tbody>
</table>

<ng-template #eligibilityActions let-patientInteractionLocation="patientInteractionLocation">
  @if (!patientInteractionLocation.saving) {
    @if (!patientInteractionLocation.editing) {
      @if (patientInteractionLocation.eligibilityStatus === eligibilityStatuses.new ||
        patientInteractionLocation.eligibilityStatus === eligibilityStatuses.ineligible) {
        <button
          type="button"
          class="btn btn-secondary action-button"
          (click)="onNewClick(patientInteractionLocation)">
          Mark Eligible
        </button>
      }
      @if (patientInteractionLocation.eligibilityStatus === eligibilityStatuses.new) {
        <button
          type="button"
          class="btn btn-secondary action-button"
          (click)="onTouchLocationClick(patientInteractionLocation)">
          Mark Ineligible
        </button>
      }
      @if (patientInteractionLocation.eligibilityPeriods.length > 0) {
        <button
          type="button"
          class="btn btn-secondary action-button"
          (click)="onEditClick(patientInteractionLocation)">
          Edit
        </button>
      }
    }
    @if (patientInteractionLocation.editing) {
      <button
        type="button"
        class="btn btn-primary action-button"
        [disabled]="!patientInteractionLocation.eligibilityPeriods[0].startDate"
        (click)="onSaveClick(patientInteractionLocation)">
        Save
      </button>
    }
    @if (patientInteractionLocation.editing) {
      <button
        type="button"
        class="btn btn-secondary action-button"
        (click)="onCancelClick(patientInteractionLocation)">
        Cancel
      </button>
    }
  } @else {
    <mat-spinner diameter="30" />
  }
</ng-template>

<ng-template #eligibilityPeriods let-patientInteractionLocation="patientInteractionLocation">
  @if (patientInteractionLocation.eligibilityPeriods.length > 0) {
    @if (patientInteractionLocation.editing) {
      <div class="eligibility-period-fields">
        <div class="eligibility-period-date-field-container">
          <div>Start:</div>
          <input
            name="startDate"
            type="date"
            class="form-control"
            autocomplete="off"
            placeholder="MM/DD/YY"
            (change)="onEligibilityPeriodDateChange(patientInteractionLocation)"
            [(ngModel)]="patientInteractionLocation.eligibilityPeriods[0].startDate" />
        </div>
        &mdash;
        <div class="eligibility-period-date-field-container">
          <div>Term:</div>
          <input
            name="terminationDate"
            type="date"
            class="form-control"
            autocomplete="off"
            placeholder="MM/DD/YY"
            (change)="onEligibilityPeriodDateChange(patientInteractionLocation)"
            [(ngModel)]="patientInteractionLocation.eligibilityPeriods[0].terminationDate" />
        </div>
      </div>
      <div class="small my-2 termination-date-note">
        Note: An eligibility period term date is not required.
      </div>
      <ng-container
        [ngTemplateOutlet]="eligibilityPeriodList"
        [ngTemplateOutletContext]="{ patientInteractionLocation: patientInteractionLocation, slice: 1 }" />
      @for (error of patientInteractionLocation.errors; track error) {
        <div class="text-danger">
          {{ error }}
        </div>
      }
    }
    @if (!patientInteractionLocation.editing) {
      <ng-container
        [ngTemplateOutlet]="eligibilityPeriodList"
        [ngTemplateOutletContext]="{ patientInteractionLocation: patientInteractionLocation, slice: 0 }" />
    }
  }

  @if (patientInteractionLocation.eligibilityPeriods.length === 0) {
    <app-blank-value-dash class="blank-eligibility-periods" />
  }
</ng-template>

<ng-template #eligibilityPeriodList let-patientInteractionLocation="patientInteractionLocation" let-slice="slice">
  @for (eligibilityPeriod of asLocation(patientInteractionLocation).eligibilityPeriods | slice: slice; track eligibilityPeriod; let i = $index) {
    <div
      [ngClass]="{ current: i === 0 && !patientInteractionLocation.editing }"
      class="eligibility-period">
      @if (enableLinkToChangelog) {
        <a class="date" target="_blank"
          routerLink="/capture-admin/change-log/PatientInteractionLocationEligibilityPeriod/{{eligibilityPeriod.id}}">
          <ng-container *ngTemplateOutlet="dates; context: { eligibilityPeriod: eligibilityPeriod }" />
        </a>
      } @else {
        <ng-container *ngTemplateOutlet="dates; context: { eligibilityPeriod: eligibilityPeriod }" />
      }
    </div>
  }
</ng-template>

<ng-template #dates let-eligibilityPeriod="eligibilityPeriod">
  <span [ngClass]="{'inactive': isInactive(eligibilityPeriod)}">
    <span>
      {{ eligibilityPeriod.startDate | date: 'MM/dd/yyyy' }}
    </span>
    &mdash;
    <span>
      @if (eligibilityPeriod.terminationDate) {
        {{ eligibilityPeriod.terminationDate | date: 'MM/dd/yyyy' }}
      }
      @if (!eligibilityPeriod.terminationDate) {
        Present
      }
    </span>
  </span>
</ng-template>

